var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: "social-media-plan-popup" + (_vm.isEdit ? " is-edit" : "") },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-7" },
              _vm._l(
                _vm._.filter(_vm.deliverableDetail.customFields, {
                  field_key: "social_media_plan_details"
                }),
                function(field, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "field-box" },
                    [
                      _c("DeliverableCustomFields", {
                        attrs: {
                          deliverable: _vm.deliverableDetail,
                          customField: field,
                          namespace: _vm.namespace
                        }
                      })
                    ],
                    1
                  )
                }
              ),
              0
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-5" }, [
              _c("div", { staticClass: "row no-gutters" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("div", { staticClass: "row no-gutters" }, [
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "div",
                          { staticClass: "tags__wrapper" },
                          [
                            _c("DeliverableListTags", {
                              attrs: {
                                deliverable: _vm.deliverableDetail,
                                namespace: _vm.namespace
                              },
                              on: { "tag-created": _vm.updateDeliverableTags }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.relatedTags.length
                          ? _c(
                              "div",
                              { staticClass: "trending-tags" },
                              [
                                _c(
                                  "label",
                                  { staticClass: "field-label-tags" },
                                  [_vm._v("Trending tags:")]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.relatedTags, function(
                                  relatedTag,
                                  index
                                ) {
                                  return _c(
                                    "a",
                                    {
                                      key: "relate-tag" + index,
                                      staticClass: "badge badge-success ml-2",
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.setTag(relatedTag)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(relatedTag.name))]
                                  )
                                })
                              ],
                              2
                            )
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      _vm._l(
                        _vm._.filter(_vm.deliverableDetail.customFields, {
                          field_key: "budget"
                        }),
                        function(field, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "field-box" },
                            [
                              _c("DeliverableCustomFields", {
                                attrs: {
                                  deliverable: _vm.deliverableDetail,
                                  customField: field,
                                  namespace: _vm.namespace
                                }
                              })
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-md-6",
                        staticStyle: { "padding-right": "10px" }
                      },
                      _vm._l(
                        _vm._.filter(_vm.deliverableDetail.customFields, {
                          field_key: "start_date"
                        }),
                        function(field, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "field-box" },
                            [
                              _c("DeliverableCustomFields", {
                                attrs: {
                                  deliverable: _vm.deliverableDetail,
                                  customField: field,
                                  namespace: _vm.namespace
                                }
                              })
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-md-6",
                        staticStyle: { "padding-left": "10px" }
                      },
                      _vm._l(
                        _vm._.filter(_vm.deliverableDetail.customFields, {
                          field_key: "end_date"
                        }),
                        function(field, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "field-box" },
                            [
                              _c("DeliverableCustomFields", {
                                attrs: {
                                  deliverable: _vm.deliverableDetail,
                                  customField: field,
                                  namespace: _vm.namespace
                                }
                              })
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _vm.hasChat()
                      ? _c("div", { staticClass: "col-md-12 field-box" }, [
                          _vm._m(0),
                          _vm._v(" "),
                          _c("div", { staticClass: "field-wrap" }, [
                            _c(
                              "div",
                              { staticClass: "chat-wrapper" },
                              [
                                _c("Chat", {
                                  attrs: {
                                    primaryParticipantId:
                                      _vm.deliverableDetail.id,
                                    primaryParticipantTitle:
                                      _vm.deliverableDetail.title,
                                    primaryParticipantType:
                                      _vm.deliverableDetail
                                        .deliverable_template_id,
                                    chatNamespace: "deliverableChat",
                                    shouldRefreshMessages: _vm.isEdit
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12 field-box" }, [
                      _c("div", { staticClass: "field-box__header" }, [
                        _c(
                          "div",
                          { staticClass: "dropdown" },
                          [
                            _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true }
                                  }
                                ],
                                staticClass:
                                  "add-resource-button exclude-outside-click d-inline-block",
                                attrs: {
                                  title: "Add resource",
                                  "data-toggle": "dropdown",
                                  "aria-expanded": "false",
                                  "data-reference": "parent"
                                }
                              },
                              [_vm._v("Resources")]
                            ),
                            _vm._v(" "),
                            _c("plus-button", {
                              attrs: {
                                "data-toggle": "dropdown",
                                "aria-expanded": "false",
                                "data-reference": "parent"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "dropdown-menu deliverable-resource-type-menu"
                              },
                              _vm._l(_vm.optionsForLinkType, function(type, i) {
                                return _c(
                                  "a",
                                  {
                                    key: i,
                                    staticClass: "dropdown-item",
                                    attrs: { href: "#" },
                                    on: {
                                      click: function($event) {
                                        return _vm.addResourceMenuItemClick(
                                          type,
                                          $event
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "link-type-icon",
                                      attrs: {
                                        src: require("@/csmworkflow/img/" +
                                          type.icon)
                                      }
                                    }),
                                    _vm._v(" " + _vm._s(type.name))
                                  ]
                                )
                              }),
                              0
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "field-box__content" },
                        _vm._l(
                          _vm._.filter(_vm.deliverableDetail.customFields, {
                            field_key: "link_url"
                          }),
                          function(resource, index) {
                            return _c(
                              "div",
                              {
                                key: "link_url-" + index,
                                staticClass: "resource-box"
                              },
                              [
                                _c("div", { staticClass: "media" }, [
                                  _c("img", {
                                    staticClass: "link-type-icon",
                                    staticStyle: { "margin-right": "3px" },
                                    attrs: {
                                      src: require("@/csmworkflow/img/" +
                                        _vm.getLinkTypeObject(
                                          _vm.customChildFieldValue(
                                            "link_type",
                                            resource.id
                                          )
                                        ).icon),
                                      draggable: "false"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "media-body" },
                                    [
                                      _c("div", {
                                        staticClass: "resource-box__url"
                                      }),
                                      _vm._v(" "),
                                      resource.value
                                        ? _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: resource.value,
                                                target: "_blank",
                                                id: "resource-" + index
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.openCopyLinkModal(
                                                    resource.value,
                                                    $event,
                                                    index
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.customChildFieldValue(
                                                    "link_label",
                                                    resource.id
                                                  ) || resource.value
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !resource.value
                                        ? _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: _vm.getResourceHref(
                                                  resource.value,
                                                  resource.id
                                                ),
                                                target: "_blank",
                                                id: "resource-" + index
                                              },
                                              on: {
                                                click: _vm.setCookieForDownload
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.customChildFieldValue(
                                                    "link_label",
                                                    resource.id
                                                  ) || resource.value
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "b-tooltip",
                                        {
                                          attrs: {
                                            target: "resource-" + index,
                                            noninteractive: "",
                                            triggers: "manual"
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-check",
                                            staticStyle: { color: "#4C9850" }
                                          }),
                                          _vm._v(" Link Copied!")
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !(
                                        !_vm.userAbilities.editMediaCall ||
                                        _vm.deliverableDetail.permissions
                                          .viewOnly
                                      )
                                        ? _c(
                                            "a",
                                            {
                                              directives: [
                                                {
                                                  name: "b-tooltip",
                                                  rawName: "v-b-tooltip.hover",
                                                  modifiers: { hover: true }
                                                }
                                              ],
                                              staticClass: "edit-resource-btn",
                                              attrs: {
                                                title: "Edit resource",
                                                href: "#"
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.editResource(
                                                    resource
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fas fa-edit"
                                              })
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.customChildFieldValue(
                                        "link_notes",
                                        resource.id
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "resource-box__notes"
                                            },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(
                                                    _vm.customChildFieldValue(
                                                      "link_notes",
                                                      resource.id
                                                    )
                                                  )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          }
                        ),
                        0
                      )
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "hide-footer": "",
            id: "createLinkModal",
            title: "New Resource / Link"
          },
          on: { shown: _vm.focusLinkModal }
        },
        [
          _c("CreateLinkModal", {
            ref: "refLinkModal",
            attrs: {
              "link-url": _vm.linkUrl,
              "link-label": _vm.linkLabel,
              "link-notes": _vm.linkNotes,
              "link-type": _vm.linkType,
              "is-file": _vm.editLinkIsFile,
              "resource-parent": "deliverable",
              namespace: _vm.namespace
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "hide-footer": "",
            id: "editLinkModal",
            title: "Update Resource / Link"
          },
          on: { shown: _vm.focusEditLinkModal }
        },
        [
          _c("EditLinkModal", {
            ref: "refEditLinkModal",
            attrs: {
              "link-url": _vm.linkUrl,
              "link-label": _vm.linkLabel,
              "link-notes": _vm.linkNotes,
              "link-type": _vm.linkType,
              "is-file": _vm.editLinkIsFile,
              namespace: _vm.namespace
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            id: "linkCopyLinkModal",
            title: "Copy Link",
            "ok-only": "",
            "ok-title": "Done"
          }
        },
        [
          _c("LinkCopyLinkModal", {
            attrs: { linkUrl: _vm.linkCopyModalValue, namespace: _vm.namespace }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "field-header" }, [
      _c("div", { staticClass: "field-label" }, [_vm._v("Chat")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }